import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Stats from './components/Stats';
import Publications from './components/Publications';
// import HKUST from './components/HKUST';
// import Benefits from './components/Benefits';
import Team from './components/Team';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <Features />
      <Stats />
      <Publications />
      {/* <HKUST /> */}
      {/* <Benefits /> */}
      <Team />
      <Footer />
    </div>
  );
}

export default App; 